import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../../App';

export const SyncFullProntoAssets = () => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.get(GetBackendUrlForGlobalFunctions() + `pronto-asset`, {
    headers,
  });
};
